import { passwordErrors } from '../commons/config';

import { Directive, forwardRef, Attribute } from '@angular/core';
import { Validator, NG_VALIDATORS } from '@angular/forms';
@Directive({
    selector: '[validatePassword][formControlName],[validatePassword][formControl],[validatePassword][ngModel]',
    providers: [
        { provide: NG_VALIDATORS, useExisting: forwardRef(() => PasswordValidatorDirective), multi: true }
    ]
})
export class PasswordValidatorDirective implements Validator {
    special_characters = /[@#$%^&+=!()]/;

    constructor( @Attribute('validatePassword') public validatePassword: string) {
    }
    validate(c: any): { [key: string]: any } {
        const pass = c.value;
        const errorArray = [];
        if (pass) {
            if (pass.length < 12) {
                errorArray.push(passwordErrors.minLength);
            }
            if (pass.search(/[0-9]/) < 0) {
                errorArray.push(passwordErrors.digit);
            }
            if (pass.search(/[A-Z]/) < 0) {
                errorArray.push(passwordErrors.upperCase);
            }
            if (pass.search(/[a-z]/) < 0) {
                errorArray.push(passwordErrors.lowerCase);
            }
            if (pass.indexOf(' ') >= 0) {
                errorArray.push(passwordErrors.blankSpace);
            }
            if (!this.special_characters.test(pass)) {
                errorArray.push(passwordErrors.specialCharacter);
            }
        }

        return errorArray;

    }
}
